<!-- 
程式：AddToCurrentGroup.vue
功能：加入現有群組(view)
作者：i9400538 陳博承
完成：2021-06-01
-->
<template>
  <main class="container-fluid" :class="{'boxPadding': isBox}">
    <form class="form">
      <section class="segment segment-padding">
        <h3 class="text-green" v-show="isShowAll">加入現有群組</h3>
        <h4 v-show="isShowAll">
          請選擇
          <span class="text-green">所選{{totalCustCount}}位客戶&nbsp;</span>想加入的群組
        </h4>
        <div class="row" v-show="isShowAll">
          <div class="col-12">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  id="Search"
                  class="form-control"
                  v-model="currentKeyword"
                  @keydown.enter="doSearch()"
                  placeholder="可輸入群組名稱進行搜尋..."
                  alt="ch"
                />
                <span id="searchclear" v-show="currentKeyword" @click="clearSearch()">清除</span>
              </div>
              <button type="button" class="btn btn-primary btn-icon" @click.prevent="doSearch()">
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </div>
        </div>

        <!--群組資料區塊-->
        <div class="row" v-show="isShowAll">
          <section class="w-100">
            <h4>&nbsp;可選擇的群組 :</h4>
            <table
              id="unsel_datatable"
              class="group-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th width="130px">#</th>
                  <th
                    id="grp_name_col"
                    :class="'sorting ' + (order.fieldName == 'grp_name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unsel', 'grp_name')"
                  >群組名稱</th>
                </tr>
              </thead>
              <tbody
                id="unsel"
                @scroll="scrollmethod"
                v-if="groupList.length"
                :style="`height: ${dt_unsel_height}px`"
              >
                <tr
                  v-for="(item, index) in groupList"
                  :key="`td-unselected-${index}-${item.grp_id}`"
                >
                  <td width="130px">
                    <div class="radio radio-inline mr-0">
                      <input
                        type="radio"
                        :id="`unselected-radio-${index}`"
                        :value="item"
                        v-model="selectedGroup"
                      />
                      <label :for="`unselected-radio-${index}`">{{index + 1}}</label>
                    </div>
                  </td>
                  <td>{{item.grp_name}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="2" class="empty">
                    <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                  </td>
                  <td v-show="false"></td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>

        <!--下一步處理完後-->
        <h3 v-show="!isShowAll">檢核結果 :</h3>
        <h4
          v-show="!isShowAll"
          class="text-red"
        >可加入群組的客戶共{{addedList.length}}位 ({{unaddedList.length}}位客戶所屬群組數已超過10個，將無法加入本次所選的群組中)。</h4>
        <!--radio區塊-->
        <div v-show="!isShowAll" class="radio radio-inline">
          <input type="radio" v-model="selectType" id="selectType1" value="1" />
          <label @click="clickLabel('1')">可加入群組的客戶({{addedList.length}})</label>
        </div>
        <div v-show="!isShowAll" class="radio radio-inline">
          <input type="radio" v-model="selectType" id="selectType2" value="2" />
          <label @click="clickLabel('2')">已達群組上限的客戶({{ unaddedList.length }})</label>
        </div>
        <!--可加入群組的客戶-->
        <div class="row" v-show="!isShowAll&&selectType=='1'">
          <section class="w-100">
            <table
              id="added_datatable"
              class="group-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th width="130px">#</th>
                  <th
                    id="col_added_name"
                    :class="'sorting ' + (order_added.fieldName == 'name' ? (order_added.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('added', 'name')"
                  >姓名</th>
                  <th
                    id="col_added_id"
                    :class="'sorting ' + (order_added.fieldName == 'showid' ? (order_added.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('added', 'showid')"
                  >身分證</th>
                  <th
                    id="col_added_birthday"
                    ref="lastCol"
                    :class="'sorting ' + (order_added.fieldName == 'birthday' ? (order_added.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('added', 'birthday')"
                  >生日</th>
                </tr>
              </thead>
              <tbody
                id="added"
                @scroll="scrollmethod"
                v-if="addedList.length"
                :style="`height: ${dt_added_height}px`"
              >
                <tr v-for="(item, index) in addedList" :key="`td-added-${index}-${item.id}`">
                  <td width="130px">
                    <span class="no">{{index + 1}}</span>
                  </td>
                  <td>
                    <Tooltip
                      :position="index < 3 ? 'bottom' : 'top'"
                      :name="item.name"
                      :id="item.showid"
                      :birthday="item.birthday"
                    >
                      <a>{{item.name | getMaskName}}</a>
                    </Tooltip>
                  </td>
                  <td>{{item.showid | getMaskID}}</td>
                  <td :width="iPadWidth">
                    <div class="date">{{item.birthday | dateFormat | getMaskBirthday}}</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="empty">
                    <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                  </td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <!--已達群組上限的客戶-->
        <div class="row" v-show="!isShowAll&&selectType=='2'">
          <section class="w-100">
            <table
              id="unadded_datatable"
              class="group-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th width="130px">#</th>
                  <th
                    id="col_unadded_name"
                    :class="'sorting ' + (order_unadded.fieldName == 'name' ? (order_unadded.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unadded', 'name')"
                  >姓名</th>
                  <th
                    id="col_sel_id"
                    :class="'sorting ' + (order_unadded.fieldName == 'showid' ? (order_unadded.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unadded', 'showid')"
                  >身分證</th>
                  <th
                    id="col_sel_birthday"
                    :class="'sorting ' + (order_unadded.fieldName == 'birthday' ? (order_unadded.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unadded', 'birthday')"
                  >生日</th>
                </tr>
              </thead>
              <tbody
                id="unadded"
                @scroll="scrollmethod"
                v-if="unaddedList.length"
                :style="`height: ${dt_unadded_height}px`"
              >
                <tr v-for="(item, index) in unaddedList" :key="`td-unadded-${index}-${item.id}`">
                  <td width="130px">
                    <span class="no">{{index + 1}}</span>
                  </td>
                  <td>
                    <Tooltip
                      :position="index < 3 ? 'bottom' : 'top'"
                      :name="item.name"
                      :id="item.showid"
                      :birthday="item.birthday"
                    >
                      <a>{{item.name | getMaskName}}</a>
                    </Tooltip>
                  </td>
                  <td>{{item.showid | getMaskID}}</td>
                  <td :width="iPadWidth">
                    <div class="date">{{item.birthday | dateFormat | getMaskBirthday}}</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="empty">
                    <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                  </td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
      </section>
    </form>

    <!--浮動區塊 -->
    <!--挑選群組時顯示-->
    <section v-if="isShowAll" class="container-fluid">
      <fixed-botton v-show="!isScroll">
        <template slot="@function">
          <div>
            <button type="button" class="btn btn-default" @click="doCancel">取消</button>
            <button
              type="button"
              class="btn btn-primary mr-0"
              @click="doNext"
              :disabled="!selectedGroup.grp_id"
            >下一步</button>
          </div>
        </template>
      </fixed-botton>
    </section>
    <!--檢核完客戶能否加入群組後顯示-->
    <section v-else class="container-fluid">
      <fixed-botton v-show="!isScroll">
        <template slot="@function">
          <div>
            <button type="button" class="btn btn-default" @click="doCancel">取消</button>
            <button type="button" class="btn btn-primary mr-0" @click="doSave">儲存</button>
          </div>
        </template>
      </fixed-botton>
    </section>

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskShowMsg" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
//component
import FixedBotton from "@/desktop/components/fixedBotton";
import Tooltip from "@/desktop/components/ToolTip";
import mxMask from "@/desktop/components/mxMask";
//service
import { getGroupOfAgnt } from "@/service";
import { getCustBy10Groups } from "@/service";
import { updateGrpMem } from "@/service";
import { getGroupMember } from "@/service";
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: "AddToCurrentGroup",
  mixins: [commonMixin],
  components: {
    FixedBotton,
    Tooltip,
    mxMask
  },
  data() {
    return {
      grpsOfAgnt: [], //所有群組
      groupList: [], //所有群組(顯示區塊)
      selectType: "1",
      selectedGroup: [], //所挑選的群組
      addedList: [], //可加入群組的客戶
      unaddedList: [], //已達群組上限的客戶
      selectedCust: [], //選取的客戶
      isShowAll: true,
      currentKeyword: "",
      keyword: "",
      dt_unsel_height: 0, //DataTable高度(選擇群組區塊)
      dt_added_height: 0, //DataTable高度(可加入群組區塊)
      dt_unadded_height: 0, //DataTable高度(已達群組上限區塊)
      order: {
        fieldName: "name",
        asc: true
      },
      order_added: {
        fieldName: "added_name",
        asc: true
      },
      order_unadded: {
        fieldName: "unadded_name",
        asc: true
      },
      mxMaskOpen: false,
      isScroll: false, //是否滾動
      scrollPostion: 25, // 顯示當前位置
      scrollPostionOffset: 10, // 1次render筆數
      isToBottom: false, // 是否捲動到最下面 (群組列表)
      isToBottom_added: false, // 是否捲動到最下面 (可加入群組的客戶)
      isToBottom_unadded: false, // 是否捲動到最下面 (已達上限的客戶)
      nowTime: 0,
      lastTime: 0,
      iPadWidth: 364,
      mxMaskShowMsg: "資料讀取中，請稍候..."
    };
  },
  watch: {
    groupdList() {
      this.registerHanlink();
    },
    addedList() {
      this.registerHanlink();
    },
    unaddedList() {
      this.registerHanlink();
    },
    // 清除關鍵字
    currentKeyword(newVal) {
      if (!newVal) {
        this.clearSearch();
      }
    }
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"]),
    isBox() {
      return this.UserInfo.userType === "box";
    },
    totalCustCount() {
      return this.selectedCust.length;
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //清除搜尋框
    clearSearch() {
      this.keyword = this.currentKeyword = "";
      if (this.groupList && this.groupList.length != this.grpsOfAgnt.length) {
        this.groupList = [...this.grpsOfAgnt];
      }
    },
    //搜尋
    doSearch() {
      this.keyword = this.currentKeyword;
      if (this.isShowAll) {
        //搜尋群組區塊
        if (this.keyword.trim() != "") {
          this.groupList = this.grpsOfAgnt.filter(item => {
            let t = item.grp_name.toUpperCase();
            let s = this.keyword.toUpperCase();
            return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
          });
        } else {
          this.groupList = [...this.grpsOfAgnt];
        }
      }
      this.registerHanlink();
    },
    //半形轉化為全形
    ToDBC(str) {
      let result = "";
      let len = str.length;
      for (let i = 0; i < len; i++) {
        let cCode = str.charCodeAt(i);
        //全形與半形相差（除空格外）：65248(十進位制)
        cCode = cCode >= 0x0021 && cCode <= 0x007e ? cCode + 65248 : cCode;
        //處理空格
        cCode = cCode == 0x0020 ? 0x03000 : cCode;
        result += String.fromCharCode(cCode);
      }
      return result;
    },
    //切換radio (可加入群組/已達群組上限)
    clickLabel(val) {
      if (this.selectType === val) {
        return;
      }
      this.clearSearch();
      this.selectType = val;
      this.registerHanlink();
    },
    //欄位排序
    processCustList(col, fieldName) {
      let order =
        col == "unsel"
          ? this.order
          : col == "added"
          ? this.order_added
          : this.order_unadded;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "birthday":
          setTimeout(() => {
            if (col == "added") {
              this.addedList.sort(this.dateCompareFun(sortOrder, fieldName));
            } else {
              this.unaddedList.sort(this.dateCompareFun(sortOrder, fieldName));
            }
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            if (col == "unsel") {
              this.groupList.sort(this.sortCompareFun(sortOrder, fieldName));
            } else if (col == "added") {
              this.addedList.sort(this.sortCompareFun(sortOrder, fieldName));
            } else {
              this.unaddedList.sort(this.sortCompareFun(sortOrder, fieldName));
            }
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //初始化
    init() {
      this.mxMaskOpen = true; //開啟遮罩
      this.selectedCust = this.$route.params.selectedCust || []; //要加入到群組的客戶
      //取得所有群組
      getGroupOfAgnt(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        0
      ).then(result => {
        this.mxMaskOpen = false; //關閉遮罩
        if (
          result.header &&
          result.header.status === "200" &&
          result.body.groups
        ) {
          this.grpsOfAgnt = result.body.groups.map(item => {
            return {
              grp_id: item.grp_id,
              grp_name: item.grp_name
            };
          });
          this.groupList = [...this.grpsOfAgnt];
        } else {
          this.groupList = [];
        }
      });
      //卷軸位置初始化
      this.resetPosition();
    },
    //滾動顯示/隱藏
    handleScroll() {
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 500);
    },
    //DataTable滾動事件
    scrollmethod(e) {
      this.nowTime = +new Date();
      if (this.nowTime > this.lastTime + 150) {
        this.lastTime = this.nowTime;
        const tempPostion = e.target.scrollTop / 69 + this.scrollPostionOffset;
        this.scrollPostion = Math.max(this.scrollPostion, tempPostion);
        let type = e.target.id; //捲動的表格 unsel(挑選群組表格) / added(可加入群組表格) / unadded(已達群組上限表格)
        let isBottom =
          "unsel" == type
            ? this.isToBottom
            : "added" == type
            ? this.isToBottom_added
            : this.isToBottom_unadded;
        if (!isBottom) {
          if (
            e.target.scrollHeight -
              e.target.scrollTop -
              e.target.clientHeight <=
            50
          ) {
            //當滾動卷軸接近底端，縮小表格高度
            if (is_iPad) {
              if ("unsel" == type) {
                this.dt_unsel_height = $(window).height() - 400;
              } else if ("added" == type) {
                this.dt_added_height = $(window).height() - 380;
              } else {
                this.dt_unadded_height = $(window).height() - 380;
              }
            } else {
              if ("unsel" == type) {
                this.dt_unsel_height = $(window).height() - 470;
              } else if ("added" == type) {
                this.dt_added_height = $(window).height() - 450;
              } else {
                this.dt_unadded_height = $(window).height() - 450;
              }
            }
            //設定是否滾到最底端判斷
            if ("unsel" == type) {
              this.isToBottom = true;
            } else if ("added" == type) {
              this.isToBottom_added = true;
            } else {
              this.isToBottom_unadded = true;
            }
          }
        }
      }
    },
    //畫面初始化(卷軸, 表格高度)
    resetPosition() {
      this.scrollPostion = 25;
      this.scrollPostionOffset = 10;
      this.dt_unsel_height = $(window).height() - 290;
      this.dt_added_height = $(window).height() - 290;
      this.dt_unadded_height = $(window).height() - 290;
    },
    //下一步
    doNext() {
      if (!this.selectedGroup.grp_id) {
        this.$toast.info({ title: "未選擇群組" });
        return;
      }
      this.mxMaskOpen = true; //開啟遮罩
      //取得已存在10個群組的客戶
      getCustBy10Groups(this.$store.state.userInfo.id).then(res => {
        this.mxMaskOpen = false; //關閉遮罩
        this.isShowAll = false;
        if (res.header && res.header.status === "200" && res.body.customers) {
          let over10groupsList = res.body.customers ? res.body.customers : [];
          if (over10groupsList && over10groupsList.length > 0) {
            if (this.selectedCust && this.selectedCust.length > 0) {
              this.selectedCust.forEach(sel => {
                let theIndex = this.checkItemIsExist(sel, over10groupsList);
                if (theIndex !== -1) {
                  this.unaddedList.push(sel); //將已超過10個群組的客戶加到unaddedList
                } else {
                  this.addedList.push(sel); //將未超過10個群組的客戶加到addedList
                }
              });
            }
          } else {
            //都沒有超過10個群組的客戶
            this.addedList = [...this.selectedCust];
          }
        } else {
          //執行出錯,顯示錯誤訊息
          this.$toast.info({ title: res.header.message });
        }

        //計算最後欄位寬度，再去扣掉卷軸寬
        setTimeout(() => {
          this.initColWidth();
        }, 20);
      });
    },
    //儲存
    doSave() {
      if (!this.addedList || this.addedList.length == 0) {
        this.$toast.info({ title: "無可加入群組的客戶，請確認。" });
        return;
      }
      this.mxMaskShowMsg = "資料儲存中，請稍候...";
      this.mxMaskOpen = true; //打開遮罩
      let addList = [];
      this.addedList.forEach(add => {
        addList.push(add.id);
      });
      let compareAry = [];
      //取得群組所有成員
      getGroupMember(
        this.$store.state.userInfo.id,
        this.selectedGroup.grp_id
      ).then(res => {
        if (res) {
          compareAry = res.map(cust => {
            return cust.ID;
          });
        } else {
          compareAry = [];
        }

        // 過濾重複 ID, insert 新ID
        addList.forEach(custId => {
          if (!compareAry.includes(custId)) {
            compareAry.push(custId);
          }
        });
        //更新群組
        updateGrpMem(
          this.$store.state.userInfo.id,
          this.selectedGroup.grp_id,
          this.selectedGroup.grp_name,
          compareAry
        ).then(result => {
          this.mxMaskOpen = false; //關閉遮罩
          if (result.header.status && result.header.status == "200") {
            this.$toast.info({ title: result.header.message });
            //儲存成功後，導頁到該群組頁面
            this.$router.push({
              path: `/group/1`,
              query: {
                grp_id: this.selectedGroup.grp_id,
                grp_name: this.selectedGroup.grp_name
              }
            });
          } else {
            //執行出錯,顯示錯誤訊息
            this.$toast.info({ title: result.header.message });
          }
        });
      });
    },
    //取消
    doCancel() {
      this.$router.go(-1);
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    },
    //檢查元素是否存在，無元素回傳-1 / 有元素回傳位置
    checkItemIsExist(item, list) {
      return list
        .map(function(e) {
          return e;
        })
        .indexOf(item.id);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.init();
    let self = this;
    $(window).bind("orientationchange", function() {
      $(window).one("resize", function() {
        self.dt_unsel_height = $(window).height() - 310;
        self.dt_added_height = $(window).height() - 310;
        self.dt_unadded_height = $(window).height() - 310;
        self.iPadWidth = self.$refs.lastCol.clientWidth;
        this.initColWidth();
      });
    });
  }
};
</script>

<style lang="scss" scoped>
#searchclear {
  position: absolute;
  right: 20px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}

::placeholder {
  line-height: normal;
}

.group-table thead tr,
.group-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.group-table tbody {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}
.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
.boxPadding {
  padding-top: 0px !important;
}
.segment-padding {
  padding: 1px 40px 10px 40px;
}
</style>
